import PropTypes from "prop-types";

import { activePollProptype } from "@/view/PollContainer/PollProptypes";
import { pollBodyCss, pollOptionsCss, pollQuestionCss } from "./PollBody.style";
import PollOptions from "./PollOptions";

const propTypes = {
  activePoll: activePollProptype.isRequired,
  editButtonSlot: PropTypes.node,
  isInteractive: PropTypes.bool,
  pollSelectorSlot: PropTypes.node,
  setSelectedValue: PropTypes.func,
  userId: PropTypes.string,
};

const PollBody = ({
  activePoll,
  editButtonSlot,
  isInteractive,
  pollSelectorSlot,
  setSelectedValue,
  userId,
}) => (
  <div css={pollBodyCss}>
    <h3 css={pollQuestionCss(isInteractive)}>{activePoll.data.question}</h3>
    <div css={pollOptionsCss}>
      {pollSelectorSlot}
      {editButtonSlot}
    </div>
    <PollOptions
      activePoll={activePoll}
      isInteractive={isInteractive}
      setSelectedValue={setSelectedValue}
      userId={userId}
    />
  </div>
);

PollBody.propTypes = propTypes;

export default PollBody;
